class CartApi {
  responseSettings = {
    method: "POST",
  }

  private async makeRequest(url: string, options?: RequestInit) {
    try {
      const response = await fetch(url, { ...this.responseSettings, ...options });
      console.log(response)
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return response;
    } catch (error) {
      console.error("An error occurred:", error);
      throw error; // Propagate the error for handling at a higher level if needed
    }
  }

  // Adds a product to the cart
  async add(productId: string, mass: string, quantity: number) {
    return await this.makeRequest(`/cart/add-product/${productId}/${mass}/${quantity}`, {
      headers: [[`X-Requested-With`, `XMLHttpRequest`]]
    });
  }

  // Changes the quantity of a product in the cart
  async change(productId: string, mass: string, quantity: number) {
    return await this.makeRequest(`/cart/change-product-quantity/${productId}/${mass}/${quantity}`, {
      headers: [[`X-Requested-With`, `XMLHttpRequest`]]
    });
  }

  // Deletes a product from the cart
  async delete(productId: string, mass: string) {
    return await this.makeRequest(`/cart/delete-product/${productId}/${mass}`, {
      headers: [[`X-Requested-With`, `XMLHttpRequest`]]
    });
  }

  // Deletes all products from the cart
  async deleteAll() {
    return await this.makeRequest(`/cart/delete-all`, {
      headers: [[`X-Requested-With`, `XMLHttpRequest`]]
    });
  }

  // Processes shipping and delivery for the cart
  async shippingAndDelivery(body: FormData) {
    const options: RequestInit = { body };
    return await this.makeRequest(`/cart/shipping-and-delivery`, options);
  }

  // Verify if email is already registered
  async verifyRegisteredEmail(email: string) {
    return await this.makeRequest(`/cart/verify-registered-email/${email}`, {
      headers: [[`X-Requested-With`, `XMLHttpRequest`]]
    });
  }
}

export const cartApi = new CartApi()

export interface cartShippingAndDeliveryData {
  forceReload: boolean
  html: string //rerendered cart-overview-box.twig
}

export interface cartData {
  headerDropdown: string // rerendered cart-overview-item.twig
  amount: number,
  product: {
    base: string
    before: string
    main: string
  }
  progress: {
    percentage: string
    remaining: string
  }
  totalPrice: {
    base: string
    main: string
  }
  success: boolean
}
export interface cartVerifyRegisteredEmailData {
  isRegistered: boolean
}
